import React, { useState } from "react";
import Footer from "../../Component/Footer";
import { Form, Formik } from "formik";
import { FormikTextField } from "../../CommonComponents/FormField";
import { Link, useNavigate } from "react-router-dom";
import Header from "../../Component/Header";
import Menu from "../../Component/Menu";
import { currentTenant, userid } from "../../Common/Credentials";
import MasterService from "../MasterService";
import { Spinner } from "react-bootstrap";
import Breadcrumb from "../../NewUI/NewComponents/Breadcrumb";
import TextfieldComponent from "../../Component/TextfieldComponent";
import { errors } from "@sideway/address";

const AddAssignType = () => {
  const navigate = useNavigate();
  const [type, setType] = useState("");
  const [loader,setLoader] = useState(false)

  const onSubmit = () => {
    let data = {
      type: type,
      createdby: userid,
      updatedby: userid,
      status:"ACTIVE",
      tenantid: currentTenant,
    };
    setLoader(true)
    MasterService.AddAssignType(data).then(() =>{
      navigate(-1)
      setLoader(false)
    }).catch(()=>setLoader(false))
  };

  const validate = () => {
    let errors = {};
    if (type === "") {
      errors.type = "This field is required.";
    }
    return errors;
  };

  return (
    <div>
      <Header />
      <Menu />
      <div className="content-wrapper">
      <div className="UI-container">
            <div className="UI-header">
          <Breadcrumb breadcrumbs={[{name:"Home",path:"/masters"},{name:"Assign",path:"/assigntype"},{name:"New Assign Type",path:null}]}/>
          </div>
            <div className="UI-form-card">
                  <Formik
                    initialValues={{}}
                    onSubmit={onSubmit}
                    validateOnChange={false}
                    validate={validate}
                    enableReinitialize={true}
                  >
                    {({ setFieldValue, values }) => (
                      <Form>
                        <div className="form-row">
                          <fieldset className="form-group col-md-4">
                            <TextfieldComponent
                              className="form-control"
                              type="text"
                              name="type"
                              label="Assign Type"
                              value={type}
                              onChange={(e) => setType(e.target.value)}
                              error={errors?.type}
                              required
                            />
                          </fieldset>
                          <fieldset className="form-group col-md-12 tw-flex tw-justify-end">
                          <button
                            type="submit"
                            className="UI-btn UI-btn-primary mr-1"
                            disabled={loader}
                          >
                            {loader ? (
                              <Spinner
                                animation="border"
                                size="sm"
                                className="mr-1"
                              />
                            ) : (
                              ""
                            )}
                            Submit
                          </button>
                          <Link
                            as="button"
                            className="UI-btn UI-btn-outline"
                            to={-1}
                            state={{ message: "" }}
                          >Cancel
                          </Link>
                          </fieldset>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AddAssignType;
